<template>
  <!--  计时烹饪模板-->
  <DetailContainer>
    <PageHeader
      slot="page-header"
      showBack
      showBreadcrumb
      @back="$router.push({ name: 'RecipeList' })"
    ></PageHeader>
    <CardContainer>
      <el-container>
        <el-aside width="220px">
          <div class="menuDiv">
            <el-menu
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
              @select="goDetail"
              :default-active="activeTab"
            >
              <el-menu-item index="basicInfo">
                <div class="menuItem">
                  <svg class="icon icon--default">
                    <use :xlinkHref="'#' + icon + '-' + this.theme"></use>
                  </svg>
                  <svg class="icon icon--selected">
                    <use :xlinkHref="'#' + icon + '-select'"></use>
                  </svg>
                  <span>{{ $t('Common.BasicInfo') }}</span>
                </div>
              </el-menu-item>
              <el-menu-item index="listFoodInfo">
                <div class="menuItem">
                  <svg class="icon icon--default">
                    <!--                  <use xlinkHref={'#' + icon + '-' + this.theme}></use>-->
                    <use :xlinkHref="'#' + icon + '-' + this.theme"></use>
                  </svg>
                  <svg class="icon icon--selected">
                    <use :xlinkHref="'#' + icon + '-select'"></use>
                  </svg>
                  <span>{{ $t('RecipeManage.listFoodInfo') }}</span>
                </div>
              </el-menu-item>
              <el-menu-item index="listPreheateInfo">
                <div class="menuItem">
                  <svg class="icon icon--default">
                    <!--                  <use xlinkHref={'#' + icon + '-' + this.theme}></use>-->
                    <use :xlinkHref="'#' + icon + '-' + this.theme"></use>
                  </svg>
                  <svg class="icon icon--selected">
                    <use :xlinkHref="'#' + icon + '-select'"></use>
                  </svg>
                  <span>{{ $t('RecipeManage.listPreheateInfo') }}</span>
                </div>
              </el-menu-item>
              <el-menu-item index="listRecipeStage">
                <div class="menuItem">
                  <svg class="icon icon--default">
                    <!--                  <use xlinkHref={'#' + icon + '-' + this.theme}></use>-->
                    <use :xlinkHref="'#' + icon + '-' + this.theme"></use>
                  </svg>
                  <svg class="icon icon--selected">
                    <use :xlinkHref="'#' + icon + '-select'"></use>
                  </svg>
                  <span>{{ $t('RecipeManage.listRecipeStage') }}</span>
                </div>
              </el-menu-item>
            </el-menu>
          </div>
        </el-aside>
        <el-container>
          <el-main style="height: 70vh; overflow-y: auto">
            <el-form
              ref="form"
              :rules="rules"
              :model="form"
              label-width="auto"
              size="small"
              label-suffix=": "
            >
              <div>
                <!--      基本信息-->
                <div id="basicInfo">
                  <div class="title-div">
                    <div class="content">{{ $t('Common.BasicInfo') }}</div>
                    <div class="backColor"></div>
                  </div>
                  <el-form-item
                    :label="$t('RecipeManage.listCurrentRecipeLang')"
                    prop="language"
                    v-if="!this.$route.query.id"
                  >
                    <el-select v-model="form.language">
                      <el-option
                        v-for="item in languageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('RecipeManage.listRecipeName')" prop="name">
                    <el-input v-model="form.name" :placeholder="$t('RecipeManage.listRecipeName')">
                    </el-input>
                  </el-form-item>
                  <el-form-item :label="$t('RecipeManage.listApplicableModel')" prop="productIds">
                    <!--                    :query="$api.product.product_select"-->
                    <!--                    :params="{-->
                    <!--                    status: 'ENABLE'-->
                    <!--                    }"-->
                    <Select
                      multiple
                      :options="productList"
                      v-model="form.productIds"
                      :placeholder="$t('RecipeManage.listApplicableModel')"
                      @getRaw="handleProductChange"
                    >
                    </Select>
                  </el-form-item>
                  <el-form-item :label="$t('RecipeManage.listRecipeType')" prop="typeId">
                    <!--                    @getRaw="handleProductChange"-->
                    <Select
                      :options="cookbookTypeList"
                      v-model="form.typeId"
                      :placeholder="$t('RecipeManage.listRecipeType')"
                      @getRaw="handleTypeChange"
                    >
                    </Select>
                  </el-form-item>
                  <el-form-item :label="$t('RecipeManage.listRecipeImg')" prop="iconBig">
                    <Upload
                      :width="160"
                      :height="108"
                      class="file__uploader"
                      :img="form.iconBig"
                      accept="image/png,image/jpg,image/jpeg"
                      @pickImg="pickImgBig"
                      :top="-30"
                      :setSize="true"
                      :imgWidth="320"
                      :imgHeight="210"
                    >
                      <template slot="tip">
                        <div style="width: 160px;text-align: center">
                          {{ $t('RecipeManage.listBigImg') }} 320×210 px
                        </div></template
                      >
                    </Upload>
                  </el-form-item>
                  <el-form-item
                    :label="$t('RecipeManage.listRecipeDescription')"
                    prop="description"
                  >
                    <el-input
                      type="textarea"
                      :rows="4"
                      v-model="form.description"
                      :placeholder="$t('RecipeManage.listRecipeDescription')"
                    >
                    </el-input>
                  </el-form-item>
                </div>
                <!--      食材信息-->
                <div style="margin-top: 40px" id="listFoodInfo">
                  <div class="title-div">
                    <div class="content">
                      {{ $t('RecipeManage.listFoodInfo')
                      }}<span>{{ '(' + $t('Common.optional') + ')' }}</span>
                    </div>
                    <div class="backColor"></div>
                  </div>
                  <el-table :data="ingredientDetailDtos" size="mini" width="100%">
                    <el-table-column :label="$t('Common.number')" type="index" width="120">
                    </el-table-column>
                    <el-table-column prop="date" :label="$t('Common.listFoodName')" min-width="220">
                      <template slot-scope="scope">
                        <!--                        allow-create-->
                        <Select
                          :key="'ingredientDetailDtos' + scope.$index"
                          class="speInput"
                          :options="foodList"
                          v-model="scope.row.ingredientId"
                          :placeholder="$t('Common.listFoodName')"
                          :disabledCode="
                            ingredientDetailDtos.map((item) => {
                              return item.ingredientId
                            })
                          "
                          @change="handleIngredient(scope.row, scope.$index)"
                        >
                        </Select>
                        <!--                        @getRaw="handleIngredient"-->
                        <!--                        @change='handleIngredient(scope.$index,scope.row)'-->
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="count"
                      key="count"
                      :label="$t('Common.listMeasure')"
                      min-width="220"
                    >
                      <template slot-scope="scope">
                        <el-input
                          class="elTableInput"
                          v-model="scope.row.count"
                          size="small"
                          :placeholder="$t('Common.tipsInput1')"
                          oninput="value=value.replace(/[^0-9]/g,'')"
                          :min="0"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="date"
                      :label="$t('Common.listMeasureUnit')"
                      min-width="220"
                    >
                      <template slot-scope="scope">
                        <!--                        allow-create-->
                        <el-select
                          class="elTableInput"
                          filterable
                          size="small"
                          allow-create
                          v-model="scope.row.unit"
                          :placeholder="$t('Common.tipsSelect1')"
                        >
                          <el-option
                            v-for="item in unitList || []"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="date"
                      :label="$t('Common.operation')"
                      fixed="right"
                      width="150px"
                    >
                      <template slot-scope="scope">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="$t('Common.moveDown')"
                          placement="top-start"
                        >
                          <el-button
                            type="text"
                            size="mini"
                            @click="foodDown(scope.$index)"
                            v-if="
                              ingredientDetailDtos.length > 1 &&
                                scope.$index !== ingredientDetailDtos.length - 1
                            "
                          >
                            <svg class="icon" aria-hidden="true" style="transform: rotate(180deg)">
                              <use xlink:href="#icon-top_arrow_16"></use>
                            </svg>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="$t('Common.moveUp')"
                          placement="top-start"
                        >
                          <el-button
                            type="text"
                            size="mini"
                            @click="foodUp(scope.$index)"
                            v-if="ingredientDetailDtos.length > 1 && scope.$index !== 0"
                          >
                            <svg class="icon" aria-hidden="true">
                              <use xlink:href="#icon-top_arrow_16"></use>
                            </svg>
                          </el-button>
                        </el-tooltip>

                        <!--                   v-if="ingredientDetailDtos && ingredientDetailDtos.length !== 1"-->
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="$t('Common.delete')"
                          placement="top-start"
                        >
                          <el-button type="text" size="mini" @click="deleteFood(scope.$index)"
                            ><svg class="icon" aria-hidden="true">
                              <use xlink:href="#icon-del_16"></use>
                            </svg>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                  <hl-button type="secondary" style="margin-top:16px" size="small" @click="addFood"
                    >{{ '＋' + ' ' + $t('RecipeManage.listFood') }}
                  </hl-button>
                </div>

                <!--             预热信息-->
                <div style="margin-top: 40px" id="listPreheateInfo">
                  <div class="title-div">
                    <div class="content">{{ $t('RecipeManage.listPreheateInfo') }}</div>
                    <div class="backColor"></div>
                  </div>
                  <el-form-item :label="$t('RecipeManage.listPreheateModal')" prop="preheatingMode">
                    <el-radio-group v-model="form.preheatingMode" @input="HandlePreheatingMode">
                      <el-radio
                        :label="item.value"
                        v-for="(item, index) in listPreheateOption"
                        :key="index"
                        >{{ item.label }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item
                    :label="$t('RecipeManage.listPreheateTemp')"
                    prop="PreheateTemp"
                    v-if="form.preheatingMode === 'CUSTOM'"
                  >
                    <el-input-number
                      class="elTableInput"
                      v-model="form.preheatingTemperature"
                      size="small"
                      :placeholder="$t('RecipeManage.listPreheateTemp')"
                      controls-position="right"
                      :min="0"
                    ></el-input-number>
                    <span class="solidUnit">℃</span>
                    <span class="Funit"> ({{ CToF(form.preheatingTemperature) }}℉)</span>
                  </el-form-item>
                </div>
                <!--             菜谱阶段-->
                <div style="margin-top: 40px" id="listRecipeStage">
                  <div class="title-div">
                    <div class="content">{{ $t('RecipeManage.listRecipeStage') }}</div>
                    <div class="backColor"></div>
                  </div>
                  <div style="margin-top:24px">
                    <hl-button
                      type="secondary"
                      size="small"
                      @click="addCookingPattern('TIMEKEEPING')"
                      >{{ '＋' + ' ' + $t('RecipeManage.listCookingPattern1') }}</hl-button
                    >
                    <hl-button
                      type="secondary"
                      size="small"
                      @click="addCookingPattern('MEDIUM_CODE_PROBE')"
                      >{{ '＋' + ' ' + $t('RecipeManage.listCookingPattern2') }}</hl-button
                    >
                    <hl-button
                      type="secondary"
                      size="small"
                      @click="addCookingPattern('TEMPERATURE_DIFF')"
                      >{{ '＋' + ' ' + $t('RecipeManage.listCookingPattern3') }}</hl-button
                    >
                    <hl-button
                      type="secondary"
                      size="small"
                      @click="addCookingPattern('FACTORY_PRESET')"
                      >{{ '＋' + ' ' + $t('RecipeManage.listCookingPattern4') }}</hl-button
                    >
                  </div>
                  <div class="secondTitle">
                    {{ $t('RecipeManage.liststageList') }}
                  </div>
                  <div class="stageListDiv">
                    <div class="stageList" v-for="(item, i) in this.cookbookFlowDtos" :key="i">
                      <div class="iconConn" v-if="activeCookStage === i">
                        <i
                          class="iconDIV el-icon-back"
                          :style="'margin-right:-8px'"
                          v-if="i !== 0"
                          @click="clickUp(i)"
                        ></i>
                      </div>
                      <div
                        :class="activeCookStage === i ? 'activeStage' : 'normalStage'"
                        @click="selectCookStage(i)"
                      >
                        <div>
                          <div class="text">
                            {{ `${$t('Common.stage')}  ${i + 1}` }}
                            {{ item.name }}
                          </div>
                        </div>
                      </div>
                      <div @click="deleteCookStage(i)" class="delButton"></div>
                      <div class="iconConnRight" v-if="i !== cookbookFlowDtos.length - 1">
                        <i
                          class="iconDIV el-icon-right"
                          @click="clickDown(i)"
                          v-if="activeCookStage === i"
                        ></i>
                        <div class="bridge"></div>
                        <!--                      <i class="iconDIV el-icon-back" :style='"margin-right:-8px"'></i>-->
                      </div>
                    </div>
                  </div>
                  <div v-if="cookPhaseObj.flowType === 'TIMEKEEPING' && reFresh">
                    <CookPattenTime
                      :ref="'CookPattenTime'"
                      :cookPhaseObj="this.cookPhaseObj"
                    ></CookPattenTime>
                  </div>
                  <div v-if="cookPhaseObj.flowType === 'MEDIUM_CODE_PROBE' && reFresh">
                    <CookPattenMid
                      :ref="'CookPattenMid'"
                      :cookPhaseObj="this.cookPhaseObj"
                    ></CookPattenMid>
                  </div>
                  <div v-if="cookPhaseObj.flowType === 'TEMPERATURE_DIFF' && reFresh">
                    <CookPattenDiff
                      :ref="'CookPattenDiff'"
                      :cookPhaseObj="this.cookPhaseObj"
                    ></CookPattenDiff>
                  </div>
                  <div v-if="cookPhaseObj.flowType === 'FACTORY_PRESET' && reFresh">
                    <CookPattenPre
                      :ref="'CookPattenPre'"
                      :cookPhaseObj="this.cookPhaseObj"
                    ></CookPattenPre>
                  </div>
                </div>

                <!--              按钮群-->
                <div class="bottomBt">
                  <hl-button type="border" @click.native="cancel">{{
                    $t('Common.cancel')
                  }}</hl-button>
                  <hl-button type="border" @click.native="preview">{{
                    $t('Common.preview')
                  }}</hl-button>
                  <hl-button @click.native="save" type="secondary">{{
                    $t('Common.save')
                  }}</hl-button>
                  <hl-button @click.native="saveAndPush" v-if="detailRoleList">{{
                    $t('Common.saveAndPush')
                  }}</hl-button>
                </div>
              </div>
            </el-form>
          </el-main>
        </el-container>
      </el-container>
    </CardContainer>
  </DetailContainer>
</template>

<script>
import { CToF } from '@/utils/utils'
import Select from '@/components/CommonForm/Select'
import Upload from '@/components/Upload'
import { uploadFile } from '@/utils/utils'
import CookPattenTime from './components/cookPattenTime'
import HlButton from '../../../components/Button'
import CookPattenMid from './components/cookPattenMid'
import CookPattenDiff from './components/cookPattenDiff'
import CookPattenPre from './components/cookPattenPre'
import { languageList, MeUnitList, EnUnitList } from '@/config/status.js'
import { getRoleByOperationCode, getRoute } from '@/authorized'
export default {
  name: 'RecipeEdit',
  components: {
    CookPattenPre,
    CookPattenMid,
    HlButton,
    // Span,
    Select,
    Upload,
    CookPattenTime,
    CookPattenDiff
  },
  data() {
    return {
      active: 0, // 当前激活的导航索引
      ingredientDetailDtos: [],
      cookbookFlowDtos: [],
      form: {
        name: '',
        description: '',
        preheatingMode: 'CUSTOM',
        preheatingTemperature: 100,
        cookbookFlowDtos: [],
        ingredientDetailDtos: [],
        productIds: [],
        language: localStorage.getItem('locale') === 'zh' ? 'zh' : 'en'
      },
      rules: {
        name: [
          { required: true, message: this.$t('RecipeManage.listRecipeName'), trigger: 'blur' }
        ],
        productIds: [
          {
            required: true,
            message: this.$t('RecipeManage.listApplicableModel'),
            trigger: 'change'
          }
        ],
        iconBig: [
          {
            required: true,
            message: this.$t('RecipeManage.listBigImg'),
            trigger: ['change', 'blur']
          }
        ]
        // iconSmall: [
        //   {
        //     required: true,
        //     message: this.$t('RecipeManage.listSmallImg'),
        //     trigger: ['change', 'blur']
        //   }
        // ]
      },
      cookPhaseObj: {},
      listPreheateOption: [
        {
          value: 'NOTHING',
          label: this.$t('RecipeManage.listPreheateOption1')
        },
        {
          value: 'CUSTOM',
          label: this.$t('RecipeManage.listPreheateOption2')
        },
        {
          value: 'LOW',
          label: this.$t('RecipeManage.listPreheateOption3')
        },
        {
          value: 'MIDDLE',
          label: this.$t('RecipeManage.listPreheateOption4')
        },
        {
          value: 'HIGH',
          label: this.$t('RecipeManage.listPreheateOption5')
        }
      ],
      activeCookStage: 0,
      langTableData: {},
      selectDiv: 'basicInfo',
      languageList,
      MeUnitList,
      EnUnitList,
      cookbookId: this.$route.query.id,
      reFresh: true,
      activeTab: 'basicInfo',
      cookbookTypeList: [],
      foodList: [],
      productList: []
    }
  },
  watch: {
    'form.language': {
      handler(newVal, oldval) {
        this.getSwitchLang(newVal)
      }
    }
  },

  computed: {
    detailRoleList() {
      let path = '/recipeManage/recipeList'.toLowerCase()
      let recipeListRole = getRoute(path, this.$store.state.menus) || {}
      let detailRole = getRoleByOperationCode(
        recipeListRole.childList,
        'updateCookbookPublishStatus'
      )
      return detailRole && detailRole.isPermission === 'Y'
    },
    unitList() {
      if (localStorage.getItem('measureUnit') === 'British') {
        return EnUnitList
      } else {
        return MeUnitList
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id)
    } else if (this.$route.query.copyId) {
      this.getDetail(this.$route.query.copyId)
    }
    this.getSwitchLang(this.form.language)
    this.getProductIds()
  },
  mounted() {
    window.addEventListener('scroll', this.getScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.getScroll)
  },
  methods: {
    CToF,
    //修改默认语言
    getSwitchLang(lang) {
      this.$ajax.get(this.$api.common.cookbook_type_select, { language: lang }).then((res) => {
        this.cookbookTypeList = res.data
      })
      this.$ajax.get(this.$api.common.foodList_select, { language: lang }).then((res) => {
        this.foodList = res.data
      })
    },
    //获取产品下拉框列表
    getProductIds() {
      const params = {
        status: 'ENABLE',
        type: 'steamingOven'
      }
      this.$ajax.get(this.$api.product.product_select, params).then((res) => {
        this.productList = res.data
      })
    },
    //获取详情
    getDetail(id) {
      const params = {
        id: id
      }
      this.$ajax.get(this.$api.recipe.detail_cookbook, params).then((res) => {
        if (res.data) {
          this.ingredientDetailDtos = res.data.ingredientDetailDtos
          this.cookbookFlowDtos = res.data.cookbookFlowDtos

          console.log('res.data.cookbookFlowDtos', res.data.cookbookFlowDtos)
          if (res.data.cookbookFlowDtos.length > 0) {
            this.activeCookStage = 0
            let obj = res.data.cookbookFlowDtos[0]
            obj.index = 0
            this.cookPhaseObj = obj
          }
          let newObj = res.data
          delete newObj.ingredientDetailDtos
          delete newObj.cookbookFlowDtos
          this.form = {
            ...newObj,
            language: newObj.defaultLanguage,
            productIds: newObj.productIdsTemp
          }
        }
      })
    },
    //取消
    cancel() {
      const { href } = this.$router.resolve({
        name: 'RecipeList'
      })
      window.open(href, '_self')
    },
    //设置食材名称,方便预览
    handleIngredient(row, index) {
      this.$nextTick(() => {
        if (row['ingredientId'] !== '') {
          let selectItem = this.foodList.find((item) => item.code === row['ingredientId'])
          console.log('selectItem', selectItem)
          this.$set(row, 'ingredientName', selectItem.name)
          this.$set(this.form.ingredientDetailDtos[index], 'ingredientName', selectItem.name)
        } else {
          console.log('修改食材3', row)
        }
      })

      // let arr = JSON.parse(JSON.stringify(this.ingredientDetailDtos))
      // let selectIndex =  arr.indexOf(item=>item.code === food.code)
      // console.log(selectIndex)
    },
    //预览
    preview() {
      //this.handlerChangeTab()
      this.handlerSaveTab()
      let params = this.form
      params.cookbookFlowDtos = this.cookbookFlowDtos
      params.ingredientDetailDtos = this.ingredientDetailDtos
      console.log('this.cookbookFlowDtos', this.cookbookFlowDtos)
      localStorage.setItem('previewData', JSON.stringify(params))
      const { href } = this.$router.resolve({
        name: 'RecipeDetail',
        query: {
          lang: params.language || params.defaultLanguage
        }
      })
      window.open(href, '_blank')
    },
    //必填项,限制项检查
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      if (!pass) {
        //  this.$message.warning('请完善食材信息')
        return false
      }
      pass = this.ingredientDetailDtos.every((el) => {
        return el.ingredientId && parseInt(el.count) && el.unit
      })
      if (!pass) {
        this.$message.warning(`${this.$t('RecipeManage.listTips18')}`)
        return false
      }
      if (this.cookbookFlowDtos.length === 0) {
        this.$message.warning(`${this.$t('RecipeManage.listTips19')}`)
        return false
      }

      return pass
    },
    //食材列表检查
    checkForm2() {
      let pass
      console.log('this.ingredientDetailDtos', this.ingredientDetailDtos)
      pass = this.ingredientDetailDtos.every((el) => {
        return el.ingredientId && parseInt(el.count) && el.unit
      })
      if (!pass) {
        this.$message.warning(`${this.$t('RecipeManage.listTips18')}`)
        return false
      }
      return pass
    },
    //仅保存
    save() {
      if (!this.checkForm2()) return
      // this.handlerChangeTab()
      this.handlerSaveTab()
      let params = this.form
      params.state = 'N'
      params.cookbookFlowDtos = this.cookbookFlowDtos
      params.ingredientDetailDtos = this.ingredientDetailDtos
      // let api = this.row.id ? this.$api.recipe.edit_cookbook : this.$api.recipe.add_cookbook
      let api = this.cookbookId ? this.$api.recipe.edit_cookbook : this.$api.recipe.add_cookbook
      if (this.$route.query.id) {
        params.id = this.$route.query.id
      }
      console.log(api)
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      this.$ajax
        .post(api, params, config)
        .then((res) => {
          // this.$message.success(`${this.row.id ? this.$t('Common.editSuccess') : this.$t('Common.createSuccess')}`)
          this.$confirm(
            `${params.id ? this.$t('Common.tips2') : this.$t('Common.tips1')}`,
            `${this.$t('Common.tips')}`,
            {
              confirmButtonText: this.$t('Common.tips3'),
              cancelButtonText: this.$t('Common.tips4'),
              type: 'success',
              beforeClose: (action, instance, done) => {
                if (action === 'confirm') {
                  this.row = {}
                  const { href } = this.$router.resolve({
                    name: 'RecipeLanguage',
                    query: {
                      id: res.data
                    }
                  })
                  window.open(href, '_self')
                  done()
                } else {
                  const { href } = this.$router.resolve({
                    name: 'RecipeList'
                  })
                  window.open(href, '_self')
                  done()
                }
              }
            }
          )
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    //保存并发布
    saveAndPush() {
      if (!this.checkForm()) return
      // this.handlerChangeTab()
      this.handlerSaveTab()
      let params = this.form
      params.state = 'Y'
      params.cookbookFlowDtos = this.cookbookFlowDtos
      params.ingredientDetailDtos = this.ingredientDetailDtos
      // let api = this.row.id ? this.$api.recipe.edit_cookbook : this.$api.recipe.add_cookbook
      let api = this.cookbookId ? this.$api.recipe.edit_cookbook : this.$api.recipe.add_cookbook
      if (this.$route.query.id) {
        params.id = this.$route.query.id
      }
      console.log(api)
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      this.$ajax
        .post(api, params, config)
        .then((res) => {
          // this.$message.success(`${this.row.id ? this.$t('Common.editSuccess') : this.$t('Common.createSuccess')}`)
          this.$confirm(
            `${params.id ? this.$t('Common.tips2') : this.$t('Common.tips1')}`,
            `${this.$t('Common.tips')}`,
            {
              confirmButtonText: this.$t('Common.tips3'),
              cancelButtonText: this.$t('Common.tips4'),
              type: 'success',
              beforeClose: (action, instance, done) => {
                if (action === 'confirm') {
                  this.row = {}
                  const { href } = this.$router.resolve({
                    name: 'RecipeLanguage',
                    query: {
                      id: res.data
                    }
                  })
                  window.open(href, '_self')
                  done()
                } else {
                  const { href } = this.$router.resolve({
                    name: 'RecipeList'
                  })
                  window.open(href, '_self')
                  done()
                }
              }
            }
          )
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    //切换tab保存信息
    handlerChangeTab() {
      this.reFresh = false
      let arr = JSON.parse(JSON.stringify(this.cookbookFlowDtos))
      if (this.cookPhaseObj.flowType === 'TIMEKEEPING') {
        arr[this.activeCookStage] = this.$refs.CookPattenTime.patten1
      } else if (this.cookPhaseObj.flowType === 'MEDIUM_CODE_PROBE') {
        arr[this.activeCookStage] = this.$refs.CookPattenMid.patten1
      } else if (this.cookPhaseObj.flowType === 'TEMPERATURE_DIFF') {
        arr[this.activeCookStage] = this.$refs.CookPattenDiff.patten1
      } else if (this.cookPhaseObj.flowType === 'FACTORY_PRESET') {
        arr[this.activeCookStage] = this.$refs.CookPattenPre.patten1
      }
      this.cookbookFlowDtos = arr
      this.$nextTick(() => {
        this.reFresh = true
      })
    },
    //不切换仅保存当前菜谱阶段
    handlerSaveTab() {
      let arr = JSON.parse(JSON.stringify(this.cookbookFlowDtos))
      if (this.cookPhaseObj.flowType === 'TIMEKEEPING') {
        arr[this.activeCookStage] = this.$refs.CookPattenTime.patten1
      } else if (this.cookPhaseObj.flowType === 'MEDIUM_CODE_PROBE') {
        arr[this.activeCookStage] = this.$refs.CookPattenMid.patten1
      } else if (this.cookPhaseObj.flowType === 'TEMPERATURE_DIFF') {
        arr[this.activeCookStage] = this.$refs.CookPattenDiff.patten1
      } else if (this.cookPhaseObj.flowType === 'FACTORY_PRESET') {
        arr[this.activeCookStage] = this.$refs.CookPattenPre.patten1
      }
      this.cookbookFlowDtos = arr
      this.reFresh = true
    },
    //锚点跳转
    goDetail(id) {
      let anchor = document.getElementById(id)
      anchor.scrollIntoView()
      this.activeTab = id
    },

    //删除菜谱阶段
    deleteCookStage(index) {
      let arr = JSON.parse(JSON.stringify(this.cookbookFlowDtos))
      arr.splice(index, 1)
      this.cookbookFlowDtos = arr
      if (arr.length === 0) {
        this.activeCookStage = -1
        this.cookPhaseObj = {}
      } else {
        this.activeCookStage = 0
        let obj = this.cookbookFlowDtos[0]
        obj.index = 0
        // this.cookbookFlowDtos.index=i;
        this.cookPhaseObj = obj
      }
    },
    // 菜谱阶段前移
    clickUp(index) {
      this.handlerChangeTab()
      this.activeCookStage = index - 1
      let arr = JSON.parse(JSON.stringify(this.cookbookFlowDtos))
      arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]))
      this.cookbookFlowDtos = arr
      // this.selectCookStage(index - 1)
    },
    // 菜谱阶段后移
    clickDown(index) {
      this.handlerChangeTab()
      this.activeCookStage = index + 1
      let arr = JSON.parse(JSON.stringify(this.cookbookFlowDtos))
      arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]))
      this.cookbookFlowDtos = arr
      //this.selectCookStage(index + 1)
    },

    // 食材信息上移
    foodUp(index) {
      let arr = JSON.parse(JSON.stringify(this.ingredientDetailDtos))
      arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]))
      this.ingredientDetailDtos = arr
    },
    // 食材信息下移
    foodDown(index) {
      let arr = JSON.parse(JSON.stringify(this.ingredientDetailDtos))
      arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]))
      this.ingredientDetailDtos = arr
    },

    //选择菜谱阶段
    selectCookStage(i) {
      this.handlerChangeTab()
      this.activeCookStage = i
      let obj = this.cookbookFlowDtos[i]
      obj.index = i
      console.log(this.cookbookFlowDtos)
      this.cookPhaseObj = obj
    },
    //添加菜谱阶段
    addCookingPattern(id) {
      if (this.cookbookFlowDtos.length > 13) {
        this.$message.warning(`${this.$t('RecipeManage.listTips3')}`)
      } else {
        const obj = { flowType: `${id}` }
        if (id === 'TIMEKEEPING') {
          obj.stageName = this.$t('RecipeManage.listCookingPattern1')
        } else if (id === 'MEDIUM_CODE_PROBE') {
          obj.stageName = this.$t('RecipeManage.listCookingPattern2')
        } else if (id === 'TEMPERATURE_DIFF') {
          obj.stageName = this.$t('RecipeManage.listCookingPattern3')
        } else {
          obj.stageName = this.$t('RecipeManage.listCookingPattern4')
        }
        this.cookbookFlowDtos.push(obj)
        this.$nextTick(() => {
          this.handlerChangeTab()
          this.selectCookStage(this.cookbookFlowDtos.length - 1)
        })
      }
    },
    // 添加食材
    addFood() {
      this.ingredientDetailDtos.push({})
    },
    // 删除食材
    deleteFood(index) {
      this.ingredientDetailDtos.splice(index, 1)
    },
    async pickImgBig(file) {
      if (file) {
        await uploadFile(file)
          .then((res) => {
            this.$set(this.form, 'iconBig', res.data)
            //this.form.iconBig = res.data
          })
          .catch(() => {})
      } else {
        this.$set(this.form, 'iconBig', '')
        // this.form.iconBig = ''
      }
    },
    async pickImgSmall(file) {
      if (file) {
        await uploadFile(file)
          .then((res) => {
            this.$set(this.form, 'iconSmall', res.data)
            //this.form.iconSmall = res.data
          })
          .catch(() => {})
      } else {
        this.$set(this.form, 'iconSmall', '')
        // this.form.iconSmall = ''
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    handleProductChange(product) {
      let nameList = product.map((item) => item.name)
      this.$set(this.form, 'productNames', nameList)
    },
    handleTypeChange(type) {
      this.form.typeName = type.name
    },
    HandlePreheatingMode(val) {
      if (val === 'CUSTOM') {
        this.form.preheatingTemperature = 100
      } else {
        this.form.preheatingTemperature = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info {
  margin-left: 24px;
}
.el-menu {
  border-right: 0;
  .el-menu-item {
    height: 40px;
    line-height: 40px;
    min-width: auto;
    border-radius: 6px;
    &.is-active {
      //background: rgba(51, 157, 255, 0.1) !important;
      background: rgba(32, 70, 199, 0.1) !important;
      span {
        position: relative;
        font-weight: 500;
        &::before {
          content: '';
          position: absolute;
          left: -24px;
          top: 4px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          border-width: 2px;
          border-style: solid;
          vertical-align: middle;
          box-sizing: border-box;
        }
      }
    }
  }
}

.title-div {
  margin-bottom: 24px;
  .content {
    font-size: 24px;
    font-weight: 600;
    color: #333333;
    line-height: 32px;
    span {
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      line-height: 32px;
      padding-left: 8px;
    }
  }
  .backColor {
    width: 100px;
    margin-top: -10px;
    height: 10px;
    background: linear-gradient(90deg, #2046c7 0%, rgba(127, 156, 255, 0) 100%);
    border-radius: 100px 0px 0px 100px;
  }
}
.elTableSelect {
  .el-input {
    width: 180px !important;
  }
}

/deep/ .elTableInput {
  width: 180px !important;
  .el-input.el-input--small.el-input--suffix {
    width: 160px !important;
  }
}

.secondTitle {
  font-weight: 600;
  color: #333333;
  line-height: 22px;
  margin: 16px auto 8px auto;
}
.stageListDiv {
  display: flex;
  max-width: 90%;
  overflow-x: auto;
  padding: 16px 10px;
  .stageList {
    display: flex;
    .activeStage {
      z-index: 2;
      width: 100px;
      height: 54px;
      background: #2046c7;
      border-radius: 8px;
      border: 2px solid #2046c7;
      line-height: 54px;
      text-align: center;
      font-weight: 600;
      color: #ffffff;
      cursor: pointer;
    }
    .normalStage {
      z-index: 2;
      width: 100px;
      height: 54px;
      background: #ffffff;
      border-radius: 8px;
      border: 2px solid #bcc7ee;
      font-weight: 600;
      color: #333333;
      line-height: 54px;
      text-align: center;
      cursor: pointer;
      &:hover {
        background: #f0f2fc;
        border-radius: 8px;
        border: 2px solid #8fa2e3;
        color: #2046c7;
      }
    }
    .delButton {
      position: relative;
      margin-left: -10px;
      margin-top: -4px;
      z-index: 3;
      width: 16px;
      height: 16px;
      background-image: url('../../../assets/common_icon_close.svg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      cursor: pointer;
      //position: fixed;
    }
    .iconConn {
      position: relative;
      margin-left: -10px;
      display: flex;
      height: 54px;
      align-items: center;
      .bridge {
        width: 40px;
        height: 8px;
        border-radius: 4px;
        // background: #e8e8e8;
        margin-left: -8px;
        margin-right: -4px;
        z-index: 1;
        background-image: url('../../../assets/cookbook_icon_stage_arrow.svg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
      }
      .iconDIV {
        z-index: 10;
        width: 16px;
        height: 16px;
        border: 1px solid #8fa2e3;
        border-radius: 8px;
        background: #ffffff;
        color: #2046c7;
        cursor: pointer;
        &:hover {
          background: #f0f2fc;
          border-radius: 12px;
          width: 24px;
          height: 24px;
          font-size: 18px;
          line-height: 20px;
          border: 2px solid #bcc7ee;
          color: #637dd7;
        }
      }
    }
    .iconConnRight {
      position: relative;
      margin-left: -10px;
      display: flex;
      height: 54px;
      align-items: center;
      .bridge {
        width: 40px;
        height: 8px;
        // margin-left:10px;
        border-radius: 4px;
        //  background: #e8e8e8;
        //padding-right: -2px;
        margin-right: -2px;
        z-index: 1;
        background-image: url('../../../assets/cookbook_icon_stage_arrow.svg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
      }
      .iconDIV {
        position: relative;
        margin-left: -4px;
        z-index: 10;
        width: 16px;
        height: 16px;
        border: 1px solid #8fa2e3;
        border-radius: 8px;
        background: #ffffff;
        color: #2046c7;
        cursor: pointer;
        &:hover {
          background: #f0f2fc;
          border-radius: 12px;
          width: 24px;
          height: 24px;
          font-size: 18px;
          line-height: 20px;
          border: 2px solid #bcc7ee;
          color: #637dd7;
        }
      }
    }
  }
}
/deep/ .speInput {
  width: 220px !important;
  .el-input.el-input--small.el-input--suffix {
    width: 200px !important;
  }
}
.bottomBt {
  background-color: #ffffff;
  left: -24px;
  right: -24px;
  position: fixed;
  bottom: 0;
  z-index: 1;
  height: 50px;
  width: calc(100vw + 240px);
  border-radius: 16px;
  text-align: right;
  padding-right: 300px;
  padding-top: 10px;
  box-shadow: 5px 0 25px 8px rgba(215, 222, 230, 0.4);
}
.el-aside {
  //width: 180px;
  border-right: 1px solid #e8e8e8;
  .menuDiv {
    width: 190px;
    margin-right: 24px;
    .menuItem {
      margin-left: -10px;
    }
  }
}
.solidUnit {
  padding-left: 4px;
  color: #333333;
  line-height: 36px;
}
.Funit {
  font-size: 16px;
  margin-left: 8px;
  color: #999999;
}
.content1 {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
}
.content2 {
  font-weight: 400;
  color: #333333;
  line-height: 22px;
}
</style>
